import React from "react";
import { ITkTableWithNoLineProps } from "../../../type/componentsType/TkTableWithNoLine";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  TypeTableHead,
  TypeTableBody,
} from "../../../type/componentsType/TkTable";
import "./_style.scss";

/**
 * TkTableWithNoLineコンポーネントは、罫線のないテーブルを表示するために使用されます。
 *
 * @param headList - テーブルのヘッダーのリスト。
 * @param bodyList - テーブルのボディのリスト。
 */
const TkTableWithNoLine: React.FC<ITkTableWithNoLineProps> = (props) => {
  const { headList, bodyList, noDataMessage = "データがありません。" } = props;

  return (
    <TableContainer>
      <Table className="tkTableWithNoLine">
        <TableHead className="tkTableHead">
          <TableRow>
            {headList?.map((item: TypeTableHead, index: number) => {
              /**
               * テーブルセルのプロパティを定義します。
               * @typedef {Object} TableCellProps
               * @property {string} headTitle - テーブルセルのタイトル。
               * @property {string} [align="center"] - テーブルセルのコンテンツの配置。
               * @property {string} [className] - テーブルセルのCSSクラス名。
               */
              const {
                headTitle,
                align = "center",
                verticalAlign,
                className,
              } = item;

              return (
                <TableCell
                  style={{
                    verticalAlign: verticalAlign,
                  }}
                  className={`tableCell ${className}`}
                  align={align}
                  key={index}
                >
                  {headTitle}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <TableBody className="tkTableBody">
          {bodyList?.length ? (
            bodyList?.map((bodyItem: TypeTableBody[], index: number) => {
              return (
                <TableRow className="tableRow" key={index}>
                  {bodyItem.map((item: TypeTableBody, index: number) => {
                    if (item.id) return null;
                    /**
                     * TkTableコンポーネントは、表形式のデータを表示するために使用されます。
                     *
                     * @param children - TkTable内に表示されるReact要素。
                     * @param align - TkTable内のセルのテキストの水平方向の配置。"left"、"center"、または"right"のいずれかを指定できます。
                     * @param className - TkTableに適用されるCSSクラス名。
                     * @param cellWidth - TkTable内の各セルの幅を指定するための数値。headListの長さに基づいて計算されます。
                     */
                    const { children, align, verticalAlign, className, width } =
                      item;

                    return (
                      <TableCell
                        style={{
                          verticalAlign: verticalAlign,
                          wordWrap: "break-word",
                          wordBreak: "break-all",
                        }}
                        width={width ? `${width}` : ""}
                        className={`tableCell ${className}`}
                        align={align}
                        key={index}
                        data-testid="tkTableBodyCellForTest"
                      >
                        {children}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell
                className="tableCell"
                align="center"
                colSpan={headList?.length}
              >
                {noDataMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TkTableWithNoLine;
